import {RESERVATION_CODE_SENDS} from "../../app/constants/storage_keys";
import {CODE_SEND_WINDOW_MIN} from "../constants/reservation_constants";
import {createTimedRecordStorage} from "./create_timed_record_storage";

// When codes were sent per property within the CRM's window, so the code limit survives closing and reopening the modal.
// Used by the flow's event handlers only, never during render

const CODE_SEND_WINDOW_MS = CODE_SEND_WINDOW_MIN * 60 * 1000;

// propertyId -> send times (epoch ms), without the ones that have left the window
const codeSendStorage = createTimedRecordStorage<number[]>({
    key: RESERVATION_CODE_SENDS,
    ttlMin: CODE_SEND_WINDOW_MIN,
    readEntry: (sentAt, now) => {
        const recent = Array.isArray(sentAt) ? sentAt.filter((time): time is number => typeof time === "number" && time > now - CODE_SEND_WINDOW_MS) : [];

        return recent.length > 0 ? recent : null;
    }
});

// Returns how many codes the property has got within the window, this one included - at least 1 when the storage is unavailable
export const recordReservationCodeSend = (propertyId: number, now: number = Date.now()): number =>
    codeSendStorage.update(propertyId, now, (sentAt = []) => [...sentAt, now]).length;
import {RESERVATION_CODE_SENDS} from "../../app/constants/storage_keys";
import {CODE_SEND_WINDOW_MIN} from "../constants/reservation_constants";
import {createTimedRecordStorage} from "./create_timed_record_storage";

// When codes were sent per property within the CRM's window, so the code limit survives closing and reopening the modal.
// Used by the flow's event handlers only, never during render

const CODE_SEND_WINDOW_MS = CODE_SEND_WINDOW_MIN * 60 * 1000;

// propertyId -> send times (epoch ms), without the ones that have left the window
const codeSendStorage = createTimedRecordStorage<number[]>({
    key: RESERVATION_CODE_SENDS,
    ttlMin: CODE_SEND_WINDOW_MIN,
    readEntry: (sentAt, now) => {
        const recent = Array.isArray(sentAt) ? sentAt.filter((time): time is number => typeof time === "number" && time > now - CODE_SEND_WINDOW_MS) : [];

        return recent.length > 0 ? recent : null;
    }
});

// Returns how many codes the property has got within the window, this one included - at least 1 when the storage is unavailable
export const recordReservationCodeSend = (propertyId: number, now: number = Date.now()): number =>
    codeSendStorage.update(propertyId, now, (sentAt = []) => [...sentAt, now]).length;
